import { Configuration } from '@azure/msal-browser'

export interface IConfigurationState {
    initialized: boolean
    apiScopes: string[]
    apiEndpoint: string
    clientId: string
    redirectUri: string
    postLogoutRedirectUri: string
}

export interface MsalConfig extends Configuration {
    auth: {
        clientId: string,
        redirectUri: string,
        postLogoutRedirectUri: string,
        authority: string
    },
    cache: {
        cacheLocation: string,
        storeAuthStateInCookie: boolean,
    }
}

export const initialMsalConfig: MsalConfig = {
    auth: {
        clientId: '',
        redirectUri: '',
        postLogoutRedirectUri: '',
        authority: 'https://login.microsoftonline.com/common'
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
}

export const initialConfigState: IConfigurationState = {    
    apiScopes: [],
    apiEndpoint: '',    
    initialized: false,
    clientId: '',
    redirectUri: '',
    postLogoutRedirectUri: '',
}